<template>
  <div class="profile_wrap">
    <div class="profile_tit">公司简介</div>
    <div class="profile_second_tit">
      针对不同的服务业办事厅提供更贴近您的需求解决方案
    </div>
    <div class="profile_detail">
      <img src="@/assets/img/profile/profile.png" />
      <div>
        <p>
          <strong>广州真卫士数码科技有限公司</strong
          >，自2009年成立以来，一直专注于为政务、服务厅、营业厅和医院等公共服务类场所提供全面的排队、自助查询解决方案。我们的业务涵盖了排队、分诊、信息显示以及自助查询设备的生产和软件系统的研发。工厂座落于佛山市顺德区北滘镇海创大族智造城12栋6楼作为一家研产销一体化的公司，我们始终坚持以客户需求为导向，以技术创新为驱动。
        </p>
        <p>
          “巨航”品牌软件系统涵盖了排队预约系统、政务排队系统、迷你排队叫号系统信息查询及发布系统等，为政务、营业厅、服务厅这类场所提供高效、便捷的排队信息自助化一体解决方案。常规分诊系统、挂号预约系统、体检排队系统、检验化验排队系统、疫苗接种排队系统以及取药排队叫号系统等,为医院提供专业、人性化的服务。
        </p>
        <p>
          我们始终致力于为客户提供最优质的产品和服务，通过不断的技术创新和市场调研，满足客户的需求,提高客户的满意度。我们相信，只有持续的进步和创新,才能使我们在政务、医疗、排队自助信息化领域保持领先地位。
        </p>
        <p>
          未来，我们将继续秉承“创新、专业、服务”的理念，不断优化产品功能和服务提高客户满意度和市场竞争力。同时，我们将积极开展市场调研和用户反馈收集工作，不断优化产品功能和服务,提高客户满意度和市场竞争。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      profile: {
        img: "",

      },
    }
  },
  methods: {
    handleToNewsDetails(index) {
      if (index === 0) {
        // window.location.href = 'https://www.ccidgroup.com/info/1098/33359.htm'
        this.$router.push('/profile_detail/1')
      } else {
        // window.location.href = 'https://www.ccidgroup.com/info/1043/33844.htm'
        this.$router.push('/profile_detail/2')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.profile_wrap {
  width: 100%;
  margin-top: 50px;
  text-align: center;
  .profile_tit {
    color: #203040;
    font-size: 40px;
    font-weight: bold;
   @media screen and (max-width: 768px) {
      font-size: 1.2rem;
    }
  }
  .profile_second_tit {
    color: rgba(32, 48, 64, 0.75);
    font-size: 22px;
    margin-top: 30px;
   @media screen and (max-width: 768px) {
      font-size: 0.8rem;
    }
  }
  .profile_detail {
    width: 70%;
    margin: 0 auto;
    margin-top: 40px;

    display: flex;
    // justify-content: space-between;
   @media screen and (max-width: 768px) {
      flex-direction: column;
      align-items: center;
      width: 95%;
    }
    img {
      width: 38%;
      height: 100%;
    }
    > div {
      padding-left: 2em;
      flex: 2;
      font-size: 20px;
      text-align: left;
      text-indent: 2em;
      line-height: 2em;
     @media screen and (max-width: 768px) {
        font-size: 0.8rem;
      }
    }
  }
}
</style>